// extracted by mini-css-extract-plugin
module.exports = {"scroll":"ScrollIndicator_scroll__3VKe0","hidden":"ScrollIndicator_hidden__16QfU","arrow":"ScrollIndicator_arrow__2yKFo"};